(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    

  (function () {

    var header = document.querySelector('[data-jm-header]');

    if (!header) return;


    /* ========================================================
       DRAWER
       ======================================================== */

    var drawer = header.querySelector('[data-jm-drawer]');
    var overlay = header.querySelector('[data-jm-drawer-overlay]');
    var openBtn = header.querySelector('[data-jm-drawer-open]');
    var closeBtn = header.querySelector('[data-jm-drawer-close]');


    function openDrawer() {

      if (!drawer || !overlay || !openBtn) return;

      drawer.classList.add('is-open');

      overlay.classList.add('is-open');

      drawer.setAttribute(
        'aria-hidden',
        'false'
      );

      openBtn.setAttribute(
        'aria-expanded',
        'true'
      );

      document.documentElement.classList.add(
        'jm-scroll-lock'
      );

    }


    function closeDrawer() {

      if (!drawer || !overlay || !openBtn) return;

      drawer.classList.remove('is-open');

      overlay.classList.remove('is-open');

      drawer.setAttribute(
        'aria-hidden',
        'true'
      );

      openBtn.setAttribute(
        'aria-expanded',
        'false'
      );

      document.documentElement.classList.remove(
        'jm-scroll-lock'
      );

    }


    if (openBtn) {

      openBtn.addEventListener(
        'click',
        openDrawer
      );

    }


    if (closeBtn) {

      closeBtn.addEventListener(
        'click',
        closeDrawer
      );

    }


    if (overlay) {

      overlay.addEventListener(
        'click',
        closeDrawer
      );

    }


    /* ========================================================
       ACCORDION MENU
       ======================================================== */

    header
      .querySelectorAll('.jm-accordion-btn')
      .forEach(function (btn) {

        btn.addEventListener(
          'click',
          function () {

            var isOpen =
              btn.getAttribute(
                'aria-expanded'
              ) === 'true';

            btn.setAttribute(
              'aria-expanded',
              String(!isOpen)
            );

            var panel =
              btn.nextElementSibling;

            if (panel) {

              panel.classList.toggle(
                'is-open',
                !isOpen
              );

            }

          }
        );

      });


    /* ========================================================
       SEARCH
       ======================================================== */

    var searchOverlay =
      header.querySelector(
        '[data-jm-search]'
      );

    var searchOpenBtn =
      header.querySelector(
        '[data-jm-search-open]'
      );

    var searchCloseBtn =
      header.querySelector(
        '[data-jm-search-close]'
      );


    function openSearch() {

      if (!searchOverlay) return;

      searchOverlay.classList.add(
        'is-open'
      );

      document.documentElement.classList.add(
        'jm-scroll-lock'
      );

      var input =
        searchOverlay.querySelector(
          'input[name="q"]'
        );

      if (input) {

        setTimeout(
          function () {
            input.focus();
          },
          60
        );

      }

    }


    function closeSearch() {

      if (!searchOverlay) return;

      searchOverlay.classList.remove(
        'is-open'
      );

      document.documentElement.classList.remove(
        'jm-scroll-lock'
      );

    }


    if (searchOpenBtn) {

      searchOpenBtn.addEventListener(
        'click',
        openSearch
      );

    }


    if (searchCloseBtn) {

      searchCloseBtn.addEventListener(
        'click',
        closeSearch
      );

    }


    /* ========================================================
       ESCAPE KEY
       ======================================================== */

    document.addEventListener(
      'keydown',
      function (e) {

        if (e.key === 'Escape') {

          closeDrawer();

          closeSearch();

        }

      }
    );

  })();


  } catch(e) { console.error(e); }
})();
})();
